// extracted by mini-css-extract-plugin
export default {"container":"Nca-z","oos":"Oca-z","oosUx":"Pca-z","selected":"Qca-z","labelOos":"Rca-z"};